import { storeWrapper } from '../storeWrapper'

const DEFAULT_FORM_PROVIDER = 'FormEvo'

const initialState = {
  mode: 'create', // 'create' | 'edit'
  matterDocumentId: null,
  selectedMatter: null,
  formProvider: DEFAULT_FORM_PROVIDER,
  selectedFormId: null
}

// Build the option shape MatterSelect expects from a matter document row
const deriveMatterFromFormData = (formData) => {
  if (!formData) return null

  const { clientNo, matterNo, clientMatterNo, matterDescription } = formData
  if (clientNo == null || matterNo == null) return null

  const resolvedClientMatterNo = clientMatterNo || `${clientNo}-${matterNo}`

  return {
    clientNo,
    matterNo,
    clientMatterNo: resolvedClientMatterNo,
    matterDescription: matterDescription ?? '',
    searchTerm: resolvedClientMatterNo
  }
}

export const useThirdPartyFormWizardStore = storeWrapper('useThirdPartyFormWizardStore', (set) => ({
  ...initialState,
  updateState: ({ key, value }) => {
    set({ [key]: value })
  },
  // Seed the store at launch so the wizard steps are purely store-driven.
  // create: pass the current matter as selectedMatter.
  // edit: pass the form's row as formData (and optionally selectedMatter).
  initialize: ({ mode = 'create', selectedMatter = null, formData = null } = {}) => {
    set({
      ...initialState,
      mode,
      matterDocumentId: formData?.matterDocumentId ?? null,
      selectedMatter: selectedMatter ?? deriveMatterFromFormData(formData),
      formProvider: formData?.formProviderName || DEFAULT_FORM_PROVIDER,
      selectedFormId: formData?.formId ?? null
    })
  },
  reset: () => set(initialState)
}))
